import { useEffect, useState } from "react";
import {
    CardCvcElement,
    CardExpiryElement,
    CardNumberElement,
} from "@stripe/react-stripe-js";
import {
    StripeCardCvcElementOptions,
    StripeCardExpiryElementOptions,
    StripeCardNumberElementOptions,
    StripeElementStyle,
} from "@stripe/stripe-js";

import useLanguage from "hooks/language";

import styles from "./card-field.module.css";

const cardElementStyle: StripeElementStyle = {
    base: {
        backgroundColor: "#FFFFFF",
        fontFamily: "Poppins, sans-serif",
        fontSize: "14px",
        fontWeight: 400,
        iconColor: "#CDCDCD",
        textAlign: "justify",
    },
};

type EditableCardFieldProps = {
    setIsValid: (areAllFieldsValid: boolean) => void;
    containerClassName?: string;
};
export function EditableCardField({
    setIsValid,
    containerClassName = styles["card-container"],
}: EditableCardFieldProps): JSX.Element {
    const { translations } = useLanguage();
    const localization = translations.upfrontPaymentSection;

    const cardNumberOptions: StripeCardNumberElementOptions = {
        iconStyle: "solid",
        placeholder: localization.paymentForm.cardNumber,
        showIcon: true,
        style: cardElementStyle,
    };
    const cardExpiryOptions: StripeCardExpiryElementOptions = {
        placeholder: localization.paymentForm.cardExpiry,
        style: cardElementStyle,
    };
    const cardCvcOptions: StripeCardCvcElementOptions = {
        placeholder: localization.paymentForm.cardCvc,
        style: cardElementStyle,
    };

    const [isCardCvcValid, setIsCardCvcValid] = useState(false);
    const [isCardExpiryValid, setIsCardExpiryValid] = useState(false);
    const [isCardNumberValid, setIsCardNumberValid] = useState(false);
    useEffect(() => {
        setIsValid(isCardCvcValid && isCardExpiryValid && isCardNumberValid);
    }, [isCardCvcValid, isCardExpiryValid, isCardNumberValid, setIsValid]);

    return (
        <div id="card-element" className={containerClassName}>
            <div className={styles["card-container__item-main"]}>
                <CardNumberElement
                    options={cardNumberOptions}
                    onChange={(e) =>
                        setIsCardNumberValid(!e.error && e.complete)
                    }
                />
            </div>
            <div className={styles["card-container__item"]}>
                <CardExpiryElement
                    options={cardExpiryOptions}
                    onChange={(e) =>
                        setIsCardExpiryValid(!e.error && e.complete)
                    }
                />
            </div>
            <div className={styles["card-container__item-end"]}>
                <CardCvcElement
                    options={cardCvcOptions}
                    onChange={(e) => setIsCardCvcValid(!e.error && e.complete)}
                />
            </div>
        </div>
    );
}
